module.exports = __webpack_public_path__ + "static/media/smartmodem-small.2ce4512f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/smartmodem-small.png
 ** module id = 1305
 ** module chunks = 0
 **/